var map = {
	"./add_photo.png": "OQKK",
	"./ar.png": "0+Yq",
	"./credit.png": "Okqa",
	"./e.svg": "aPJP",
	"./emarf.svg": "uxqG",
	"./factory_1.png": "eWUC",
	"./factory_default.png": "Y4Jb",
	"./fillet/dogBone.jpg": "2atl",
	"./fillet/typeA.jpg": "rKnH",
	"./fillet/typeB.jpg": "yhNZ",
	"./fillet/typeH.jpg": "mU/i",
	"./fillet/typeI.jpg": "DVmE",
	"./hanko.png": "wvb+",
	"./howto/step1.png": "VLo2",
	"./howto/step2.png": "K5M2",
	"./howto/step3-1.png": "Nw3i",
	"./howto/step3-2.gif": "39cT",
	"./howto/step4.png": "Aqql",
	"./howto/step5.png": "j+rW",
	"./lab.svg": "uP9C",
	"./location_logo.png": "FRYG",
	"./material_test.png": "mrC/",
	"./picture_default.png": "84LN",
	"./plugin/add-bin.svg": "vQuV",
	"./plugin/arrow_down.svg": "KFdZ",
	"./plugin/arrow_up.svg": "h8ZH",
	"./plugin/back.svg": "xuLy",
	"./plugin/board.svg": "v+M9",
	"./plugin/downcut.svg": "HakR",
	"./plugin/edit.svg": "NeGJ",
	"./plugin/external.svg": "DABX",
	"./plugin/forward.svg": "PiSI",
	"./plugin/generate.svg": "j6f3",
	"./plugin/inside.svg": "1oK4",
	"./plugin/minus.svg": "mPcm",
	"./plugin/more.svg": "qY6s",
	"./plugin/nesting.svg": "tboI",
	"./plugin/note.svg": "pRXs",
	"./plugin/order.svg": "eqoC",
	"./plugin/order_green.svg": "8XoB",
	"./plugin/outside.svg": "xzN6",
	"./plugin/pdf.svg": "Slhx",
	"./plugin/play.svg": "SvqX",
	"./plugin/plus.svg": "QFue",
	"./plugin/redo.svg": "yYKm",
	"./plugin/remove-bin.svg": "Siz8",
	"./plugin/reset.svg": "FCAi",
	"./plugin/save.svg": "xnJe",
	"./plugin/save_green.svg": "AuAD",
	"./plugin/select_box.svg": "Cbz1",
	"./plugin/select_box_caret.svg": "Ob12",
	"./plugin/select_box_caret44.svg": "5Pug",
	"./plugin/shopbot.svg": "bPqK",
	"./plugin/stop.svg": "m5U/",
	"./plugin/tab-rect.svg": "LEfi",
	"./plugin/tab-triangle.svg": "2XEe",
	"./plugin/tab-trimmer.svg": "DCrQ",
	"./plugin/undo.svg": "OFwj",
	"./plugin/upcut.svg": "YLfu",
	"./plus_circle.png": "p6WJ",
	"./shopbot-desktop-max.png": "6tX1",
	"./shopbot-desktop.png": "OguA",
	"./shopbot-prs-alpha.png": "Ha5J",
	"./slider.png": "xlXo",
	"./templates/template-bench.png": "B+Dr",
	"./templates/template-board-rec.png": "j6kr",
	"./templates/template-board-round.png": "6k18",
	"./templates/template-shelf.png": "ZyEk",
	"./templates/template-stool.png": "HDTV",
	"./templates/template-table.png": "qPKq",
	"./ui/cc.svg": "dbG1",
	"./ui/close.png": "AXD4",
	"./ui/dot-border.png": "H8kj",
	"./ui/download-sbp-black.png": "nZWD",
	"./ui/download-sbp.png": "aS4w",
	"./ui/download.png": "kfcg",
	"./ui/drag-and-drop.png": "3atk",
	"./ui/drag-to-move-black.png": "7eJK",
	"./ui/drag-to-move.png": "IS6O",
	"./ui/editing-icon.png": "FNy8",
	"./ui/emarf.png": "mfO3",
	"./ui/error.svg": "jnga",
	"./ui/gear.png": "hEl9",
	"./ui/gear_white.png": "sFE6",
	"./ui/left-arrow.png": "h47J",
	"./ui/loading.gif": "IZEA",
	"./ui/right-arrow.png": "Y6lE",
	"./ui/simulate-icon-black.png": "yD2c",
	"./ui/simulate-icon.png": "hdIs",
	"./ui/template-icon.png": "9yfc",
	"./ui/template-stool.png": "FA0I",
	"./ui/templates-left-arrow.png": "rE/R",
	"./ui/templates-right-arrow.png": "muUF",
	"./ui/timeline-start.svg": "I47n",
	"./ui/timeline-stop.svg": "O19+",
	"./ui/trash.png": "vWFd",
	"./ui/upload-icon.png": "IXpq",
	"./ui/warning.svg": "mULI",
	"./website_logo.png": "gTpV"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "g2Y0";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images ^\.\/.*$
// module id = g2Y0
// module chunks = 1